import { SITE_TASK_ORDER_TYPE } from './ProcessConst';

/** タスク検索用ステータス */
export const SEARCH_STATUS = {
  ALL: {
    value: 1,
    label: 'ステータス' //プレースホルダ
  },
  NOT_STARTED: {
    value: 2,
    label: '未着手'
  },
  IN_PROGRESS: {
    value: 3,
    label: '着手中'
  },
  COMPLETED: {
    value: 4,
    label: '完了'
  },
  UNNECESSARY: {
    value: 5,
    label: '実施不要'
  },
  ALERT_ONLY: {
    value: 6,
    label: 'アラートのみ'
  }
};

export const SEARCH_STATUS_VALUES = [
  1, // すべて
  2, // 未着手
  3, // 着手中
  4, // 完了
  5, // 実施不要
  6 // アラートのみ
];

export const SITE_TASK_STATUS = {
  // 未実施
  NOT_STARTED: {
    value: 1,
    label: '未着手'
  },
  // 実施中
  IN_PROGRESS: {
    value: 2,
    label: '着手中'
  },
  // 完了
  COMPLETED: {
    value: 3,
    label: '完了'
  },
  // 実施不要
  UNNECESSARY: {
    value: 4,
    label: '実施不要'
  }
};

// 新規・編集モーダルの発注書のラジオボタン用設定
export const SITE_TASK_FORM_ORDER_TYPE_LIST = [
  { name: '外注発注', value: SITE_TASK_ORDER_TYPE.outsources },
  { name: '商品発注', value: SITE_TASK_ORDER_TYPE.merchandise }
];

// タスクのステータス管理
export const SITE_TASK_STATUS_NOT_STARTED = 1; // 未着手
export const SITE_TASK_STATUS_IN_PROGRESS = 2; // 進行中
export const SITE_TASK_STATUS_COMPLETED = 3; // 完了
export const SITE_TASK_STATUS_UNNECESSARY = 4; // 実施不要};

// タスクのステータスを配列で保持
export const SITE_TASK_STATUSES = [
  SITE_TASK_STATUS_NOT_STARTED,
  SITE_TASK_STATUS_IN_PROGRESS,
  SITE_TASK_STATUS_COMPLETED,
  SITE_TASK_STATUS_UNNECESSARY
];

/** タスク履歴の検索用項目 */
export const SITE_TASK_ITEM_LIST = [
  {
    value: 1,
    label: 'タスク'
  },
  {
    value: 2,
    label: '担当者'
  },
  {
    value: 3,
    label: '工程'
  },
  {
    value: 4,
    label: '期限'
  },
  {
    value: 5,
    label: '内容'
  },
  {
    value: 6,
    label: 'ステータス'
  },
  {
    value: 7,
    label: '発注書区分'
  },
  {
    value: 8,
    label: '発注書'
  },
  {
    value: 9,
    label: '完了日'
  }
];
